import type { Earning } from "../../types";
import { formatDate } from "../../utils/dates";
import { StatusBadge } from "./Tag";

interface EarningRowProps {
  earning: Earning;
}

export function EarningRow({ earning }: EarningRowProps) {
  const isNil = earning.status === "failed" || earning.status === "qa_fail";

  return (
    <div className="hist-item">
      <div className="hist-title title-medium title-subtle">
        {earning.title}
      </div>
      <div className="hist-date">{formatDate(earning.date)}</div>
      <div className={`hist-pts ${isNil ? "nil" : "pos"}`}>
        {isNil ? "—" : `+${earning.points} pts`}
      </div>
      <StatusBadge status={earning.status} />
    </div>
  );
}
